/**
 * Format date strings for HTML date input elements
 * @param {string} dateStr - ISO date string from API
 * @returns {string} Formatted date string for input[type="datetime-local"]
 */
export const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 16);
};
